
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10 md:mb-12">
          <div>
            <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4">有限会社ファーム建設</h4>
            <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
              横浜市を中心に、建設・不動産・リフォームなど幅広いサービスを提供しています。
            </p>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4">サービス</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer text-xs md:text-sm">
                  建設・設計
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer text-xs md:text-sm">
                  不動産売買・賃貸
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer text-xs md:text-sm">
                  リフォーム
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base md:text-lg font-bold mb-3 md:mb-4">会社情報</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer text-xs md:text-sm">
                  会社概要
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer text-xs md:text-sm">
                  サービス
                </a>
              </li>
              <li>
                <a href="https://lin.ee/0JOwaod" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer text-xs md:text-sm">
                  お問い合わせ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 md:pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4">
            <p className="text-gray-400 text-xs md:text-sm">
              © {currentYear} 有限会社ファーム建設. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 text-xs md:text-sm transition-colors duration-300 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
